"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOutlineChildrenSystem = void 0;
var core_1 = require("@inter-ikea-core/core");
var SystemBase2_1 = require("../systembase/SystemBase2");
var SimpleOutlineBlockingSystem_1 = require("./SimpleOutlineBlockingSystem");
var SimpleOutlineModelSystem_1 = require("./SimpleOutlineModelSystem");
var SimpleOutlineSelectedSystem_1 = require("./SimpleOutlineSelectedSystem");
/**
 * This system acts on the outline component, and propagates the outline state to children recursively.
 */
var SimpleOutlineChildrenSystem = /** @class */ (function (_super) {
    __extends(SimpleOutlineChildrenSystem, _super);
    function SimpleOutlineChildrenSystem() {
        var _this = _super.call(this, core_1.ComponentIds.OUTLINED_COMPONENT_ID, core_1.ComponentIds.CHILD_COMPONENT_ID) || this;
        _this.id = SimpleOutlineChildrenSystem.systemID;
        _this.doingChangesOnComponent = [];
        _this.systemsAfterMe = [
            SimpleOutlineModelSystem_1.SimpleOutlineModelSystem.systemID,
        ];
        _this.systemsBeforeMe = [
            SimpleOutlineBlockingSystem_1.SimpleOutlineBlockingSystem.systemID,
            SimpleOutlineSelectedSystem_1.SimpleOutlineSelectedSystem.systemID
        ];
        return _this;
    }
    SimpleOutlineChildrenSystem.prototype.onAddComponent = function (entity, _newComponent) {
        if (entity.hasComponent(core_1.ComponentIds.PARENT_COMPONENT_ID)) {
            this.addOutlineToChildren(entity);
        }
    };
    SimpleOutlineChildrenSystem.prototype.onRemoveComponent = function (entity, _oldComponent) {
        if (entity.hasComponent(core_1.ComponentIds.PARENT_COMPONENT_ID)) {
            this.removeOutlineFromChildren(entity);
        }
    };
    SimpleOutlineChildrenSystem.prototype.onUpdateComponent = function (_entity, _oldComponent, _newComponent) {
        // Do nothing.
    };
    SimpleOutlineChildrenSystem.prototype.addOutlineToChildren = function (entity) {
        core_1.HierarchyUtils.children(entity).forEach(function (child) {
            child.addComponent(new core_1.OutlinedComponent());
        });
    };
    SimpleOutlineChildrenSystem.prototype.removeOutlineFromChildren = function (entity) {
        core_1.HierarchyUtils.children(entity).forEach(function (child) {
            child.removeComponent(core_1.ComponentIds.OUTLINED_COMPONENT_ID);
        });
    };
    SimpleOutlineChildrenSystem.prototype.onAddComponent2 = function (entity, _newComponent) {
        this.updateChildren(entity);
    };
    SimpleOutlineChildrenSystem.prototype.onRemoveComponent2 = function (_entity, _oldComponent) {
        // Do nothing.
    };
    SimpleOutlineChildrenSystem.prototype.onUpdateComponent2 = function (entity, _oldComponent, _newComponent) {
        this.updateChildren(entity);
    };
    SimpleOutlineChildrenSystem.prototype.updateChildren = function (entity) {
        if (entity.hasComponent(core_1.ComponentIds.OUTLINEABLE_COMPONENT_ID)) {
            var outlinedParent = core_1.HierarchyUtils.findWithComponentInUpwardsHierarchy(entity, core_1.ComponentIds.OUTLINED_COMPONENT_ID);
            if (outlinedParent) {
                entity.addComponent(new core_1.OutlinedComponent());
            }
        }
    };
    SimpleOutlineChildrenSystem.systemID = 'SimpleOutlineChildrenSystem';
    return SimpleOutlineChildrenSystem;
}(SystemBase2_1.SystemBase2));
exports.SimpleOutlineChildrenSystem = SimpleOutlineChildrenSystem;
//# sourceMappingURL=SimpleOutlineChildrenSystem.js.map